import { EVENT } from "@/constants/event";

/**
 * @param {any} set
 * @param {any} get
 * @param {any} api
 */
export default (set, get) => ({
  isFilterVisible: false,
  setFilterVisible: (visible) => {
    set({ isFilterVisible: visible });
    window.dispatchEvent(
      new CustomEvent(EVENT.FILTER_VISIBLE_CHANGE, { detail: visible })
    );
  },
  // 获取选中的筛选项数量
  getSelectedCount: () => {
    const state = get();
    const selectedFilters = state.selectedFilters || {};
    return Object.keys(selectedFilters).length;
  },
  // 设置选中的筛选项
  setSelectedFilters: (filters) => {
    set({ selectedFilters: filters });
  },
  // 清空选中的筛选项
  clearSelectedFilters: () => {
    set({ selectedFilters: {} });
  },
});
